import {
    IChangeStickyHeaderDefaultStateAction,
    IUpdateInvoiceEnquiriesActionHeader,
    IUpdateDrilldownEnquiriesActionHeader,
    IStickyHeaderInitStateAction,
    IToggleCancelModalAction
} from '../actions/sticky-header-actions';
import { IBillingState } from '../state';

export const resetStickyHeaderState =
    (state: IBillingState, action: IStickyHeaderInitStateAction) => {
        return {
            ...state,
            stickyHeader: {
                ...state.stickyHeader,
                enquiryEnabled: false,
                selectedItems: [],
                selectedProductsCount: 0,
                totalCount: 0
            }
        }
    };

export const changeStickyHeaderSelectedItems =
    (state: IBillingState, action: IUpdateInvoiceEnquiriesActionHeader) => {
        const selectedItems = [...state.stickyHeader.selectedItems];
        selectedItems[action.data.offerOrder] = action.data;
        Object.keys(selectedItems).forEach((k) => (selectedItems[k] == null || !selectedItems[k]) && delete selectedItems[k]);
        const selectedProductsCount = selectedItems.reduce((acc, offer) => {
            if (offer && acc !== undefined) {
                acc += offer.selectedProducts?.filter((val) => Object.keys(val.selectedServices).length > 0).length;
                return acc;
            }
        }, 0)
        const totalCount = selectedItems?.reduce((acc, offer) => {
            const cnt = offer?.selectedProducts.reduce((acc1, product) => {
                acc1 = (product.selectedServices?.planCharges?.length || 0) +
                    (product.selectedServices?.onceOffChargesAndCredits?.length || 0) +
                    (product.selectedServices?.usageSummaryCharges?.length || 0)
                return acc1;
            }, 0);
            acc = acc + cnt;
            return acc;
        }, 0);

        sessionStorage.setItem('TC:Billing:Enquiries', JSON.stringify(selectedItems));
        return {
            ...state,
            stickyHeader: {
                ...state.stickyHeader,
                selectedItems,
                selectedProductsCount,
                totalCount
            }
        }
    };

export const changeStickyHeaderSelectedItemsDrilldown =
    (state: IBillingState, action: IUpdateDrilldownEnquiriesActionHeader) => {
        const selectedProductsCount = action.data;
        return {
            ...state,
            stickyHeader: {
                ...state.stickyHeader,
                selectedProductsCount
            }
        }
    };

export const changeStickyHeaderDefaultState =
    (state: IBillingState, action: IChangeStickyHeaderDefaultStateAction) => {
        if (!state.stickyHeader.enquiryEnabled) {
            sessionStorage.removeItem('TC:Billing:Enquiries');
        }
        return {
            ...state,
            stickyHeader: {
                ...state.stickyHeader,
                enquiryEnabled: !state.stickyHeader.enquiryEnabled
            }
        }
    };

export const toggleCancelModalState =
    (state: IBillingState, action: IToggleCancelModalAction) => {
        return {
            ...state,
            stickyHeader: {
                ...state.stickyHeader,
                modalVisible: !state.stickyHeader.modalVisible
            }
        }
    };
